import {
  CloseButton,
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useApp } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

function NavigationDesktopDropdown(props) {
  const { menuItems, title } = props;

  const { isCustomer } = useApp();

  return (
    <Popover className="relative">
      <PopoverButton className="inline-flex items-center gap-x-1 border-b-2 border-b-transparent p-2 font-medium text-black text-sm outline-white/0 outline-offset-0 hover:border-b-rcprimary-400 hover:text-rcprimary-400">
        <span>{title}</span>
        <ChevronDownIcon className="size-5" aria-hidden="true" />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute left-1/2 z-30 mt-2 flex w-screen max-w-max -translate-x-1/4 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-leave:duration-150 data-enter:ease-out data-leave:ease-in"
      >
        <div
          className={`w-screen max-w-md flex-auto overflow-hidden rounded-3xl shadow-lg outline-1 ${isCustomer ? 'bg-rcgray-50 outline-gray-900/5' : 'bg-gray-800 shadow-none outline-white/10'} text-sm leading-6 ring-1 ring-gray-900/5`}
        >
          <div className="p-4">
            {menuItems.map((item) => (
              <div
                key={item.name}
                className={`${isCustomer ? 'hover:bg-rcprimary-400/10' : 'hover:bg-gray-100/10'} group relative flex gap-x-6 rounded-lg p-4`}
              >
                <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg border border-rcprimary-400 group-hover:bg-transparent">
                  <item.icon
                    className="size-6 text-rcprimary-400"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <CloseButton
                    as={NavLink}
                    to={item.to}
                    className={`font-semibold ${isCustomer ? 'text-black/80 group-hover:text-black' : 'text-white/90 group-hover:text-white'} `}
                  >
                    {item.name}
                    <span className="absolute inset-0" />
                  </CloseButton>
                  <p
                    className={`mt-1 ${isCustomer ? 'text-black/60 group-hover:text-black' : 'text-white/70 group-hover:text-white'} `}
                  >
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PopoverPanel>
    </Popover>
  );
}

NavigationDesktopDropdown.propTypes = {
  menuItems: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default NavigationDesktopDropdown;
